/*============================================================================
Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() { 
$cart = $("#cart");
$.ajax({
  url: '/cart.js',
  dataType: 'json',
  type: 'post',
  data: $cart.serialize(),
  success: function (data) { 
  	refreshCart(data);
  }
});
}

function refreshCart(cart) { 
    $cartBtn = $(".icon-cart span");
    if ($cartBtn && $cartBtn.size()) {  
//       var value = $cartBtn.text() || '0';
      var value = cart.item_count ? cart.item_count : '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      var cartSpecialMessage = "";
      
      //alert(shopCurrency);
      
      $cartBtn.text(value);
      $cart.find('li:not(:first)').remove();
      
      if (cart.item_count <= 0) { 
        
        $cart.html('');
        $cart.append("<li class='empty_cart'>Your Bag is Empty</li>");                                         
        $(".cart-button").removeClass('itemincart');             
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>');
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));    
        $(".addbag_count").hide();
        
      } else { 
        	
        $.each(cart.items, function(index, item) {
          var var_id = '';
          if (item.properties._sample_id == undefined && item.properties._sample_variant != undefined) {
            var_id = item.variant_id;
          } else if (item.properties._sample_id != undefined){
             var_id = item.properties._sample_id;
          }
          cart_items_html += '';
          cart_items_html += '<li class="cart_item last_cart_item">' +
             '<div class="cart_image" style="background:url(' + item.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '') + ') center center no-repeat;">' +
             '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" style="width:100%" />' +
             '</div>' +
            
             '<div class="cartitem_info">'+
               '<div class="cart item_title full">'+
                '<div class="item_title cart_item_title">' + item.product_title + '</div>' +
              '<div class="mm-counter cart-quantity">' +
             '<span class="alabel">Quantity</span>' +	
             '<div class="cart-quantity">' +
             '<span class="quantity-count minus ss-icon minus">&#x002D;</span>' +
             '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
             '<span class="quantity-count plus ss-icon plus">&#x002B;</span>' +
             '</div>' +
             '</div>' +
             '</div>' +
             
            '<div class="cart_item_right" data-qty="'+ item.quantity +'" data-sku="'+ item.sku +'">' +			 
             '<div class="provar">' +
			 '<span style="display:inline-block;">' + item.variant_title + '</span>' +
             '</div>';

		
            
            cart_items_html += '</div>' +
              '<div class="cart item_price full">' +
             '<div class="price item_price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) +'</div>' +
              '<div class="removelink">' +
			 '<a href="javascript:void(0)" class="removelink_del" onclick="remove_item(' + item.variant_id + '); return false;">Remove</a>' +
			 '</div>' +
			 '</div>' +
              '</div>' +
			 '</li>' ; 
        });
		
		 
		 cart_items_html += '<div class="totals_wrapper">' +
		  //'<div class="special_cart_message">'+ cartSpecialMessage +'</div>' + 
          '<div class="border_btn"><span>Subtotal ' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span><a href="/cart">Checkout</a></div></div>';
		
        
        $(".cart-button").addClass('itemincart');
        
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' +cart.item_count+ ')</a>');
          
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));  

        $cart.html(cart_items_html);
        //$cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
     
          if($('.currencies:visible option:selected').val()) {
            Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val()); 
          }
		
		$("#added-box-wrapper").fadeIn();
      	
        //$(".mobile_success_msg").fadeIn(1500);
        //$(".mobile_success_msg").fadeOut(1500);
		
		$('span#AddToCartText-product-template').delay(500).text('ADDED!')
				
        $(".addbag_count").show();
        $('.template-collection .modal').fadeOut();
        $('body').removeClass('modal-open');
        $('.close-reveal-modal').click();
        
        //
        var wheight = $(window).height();
    	var header_height = $('#shopify-section-header').height();
    	var boxheight = $("#added-box-wrapper").innerHeight();
    	var total_height = $(".totals_wrapper ").innerHeight();
    
    	//$("#added-box-wrapper").css('height', (wheight - header_height - 25));
  		//$("#added-box ul").css('height', (boxheight - 207 - 20));
        
        setTimeout(function() { 
          	$("#added-box-wrapper").fadeOut();
        }, 2000);                        
      }
    }


    
  }  
  
function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }} 	
	
function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
//   document.getElementById('cart').reset();
  
  ajaxSubmitCart();
}	

$(document).on('click', '.removelink_del', function (e) {
  e.preventDefault();
  document.getElementById('updates_'+ $(this).attr('data-variant-id')).value = 0;
  if ($(this).attr('data-main-id') != '') {
    $('[data-variant-id="'+ $(this).attr('data-main-id') +'"][data-sample-variant="'+ $(this).attr('data-sample-variant') +'"]').parents('.cart_item_right').find('input.quantity').val(0)
  }
  ajaxSubmitCart();
  
});

$(document).on('click', '.remove-bundles', function (e) {
  if ($(this).attr('data-main-id')) {
    e.preventDefault();

    var updates_url = 'updates['+ $(this).data('key') +']=0&updates['+ $('[data-variant-id="'+ $(this).attr('data-main-id') +'"][data-sample-variant="'+ $(this).attr('data-sample-variant') +'"]').data('key') +']=0';

    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: updates_url,
      success: function (data) {
        window.location.href = '/cart';
      }
    });
  }
});
  
$(document).on("change", "#cart input", function() { 
  	//alert('1');
    ajaxSubmitCart();
});  
  
$(document).on("click", ".minus", function() { 
  	var quantity = parseInt($(this).next("input").val()); 
    var qty = quantity;
    
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    
    if (qty <= 0) {
   		$(this).closest('li.cart_item').addClass('animated fadeOutUp')
      	setTimeout(ajaxSubmitCart, 500);
    } else {
      	ajaxSubmitCart();
    }
  });  

$(document).on("click", ".plus", function() { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
  });
  

$(document).on("submit",".product_form", function(e) { 
  e.preventDefault();
  var $addToCartForm = $(this);
  
  var hasSample = $('.selected-bundle').length && $('.selected-bundle').attr('data-bundle-qty') != '';
  
  if (hasSample) {
    $('#complementary-id').val($('[data-current-variant-id="'+ $('.product-form__variants').val() +'"]').attr('data-related-variant-id'));
  } else {
    $('#complementary-id').val('');
  }
  
  addToCart($addToCartForm.serialize(), hasSample);
  
});

function addToCart(data, sample) {
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: data,
    success: function(response) {
      
      if (sample) {
        var data = {
          id: $('[data-current-variant-id="'+ response.id +'"]').attr('data-related-variant-id'),
          quantity: $('.selected-bundle').attr('data-bundle-qty')
        };

        if ($('#complementary-variant').val()) {
          data.properties = {
            _sample_variant: $('#complementary-variant').val(),
            _sample_id: $('.product-form__variants').val()
          }
        }
        addToCart(data);
      } else {
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
          window.setTimeout(function(){ $('.cart-button').click(); }, 500);
        });
      }
    },
    error: function(XMLHttpRequest) {
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      $('.warning').remove();
      //var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      $addToCartBtn.after(warning);
      $addToCartBtn.removeAttr('disabled').removeClass('disabled');
      $addToCartBtn.find('span').text("Add to Basket").removeClass('zoomOut').addClass('zoomIn');
    }
  });
}